import { useState, useEffect } from 'react';
import { Btn } from '../components/Basic.jsx';
import { t as tr } from '../lib/i18n.js';
// Ogni passaggio naviga DAVVERO verso quella schermata (riusa go(), quindi
// arriva anche con la stessa animazione a pagina che sfoglia già presente
// nell'app) — non sono finte immagini, è l'app vera sotto la scheda.
function buildTourSteps(){
  return [
    {goTarget:"feed",screenName:"feed",title:tr("tour_step1_title"),body:tr("tour_step1_body")},
    {goTarget:"capture",screenName:"capture",title:tr("tour_step2_title"),body:tr("tour_step2_body")},
    {goTarget:"library",screenName:"library",title:tr("tour_step3_title"),body:tr("tour_step3_body")},
    {goTarget:"micro",screenName:"micro",title:tr("tour_step4_title"),body:tr("tour_step4_body")},
    {goTarget:"notebook",screenName:"notebook",title:tr("tour_step5_title"),body:tr("tour_step5_body")},
    {goTarget:"profile_me",screenName:"profile",title:tr("tour_step6_title"),body:tr("tour_step6_body")},
  ];
}
export function GuidedTour({go,t,onFinish}){
  const [tourSteps]=useState(buildTourSteps);
  const [stepIndex,setStepIndex]=useState(0);
  const step=tourSteps[stepIndex];
  useEffect(()=>{ go(step.goTarget); },[stepIndex]);
  const next=()=>{
    if(stepIndex>=tourSteps.length-1){ onFinish(); return; }
    setStepIndex(i=>i+1);
  };
  return(
    <div style={{position:"fixed",left:0,right:0,bottom:0,zIndex:260,padding:"0 16px 22px",pointerEvents:"none"}}>
      <div style={{background:"#fff",borderRadius:20,padding:"20px 20px 18px",boxShadow:"0 -8px 40px rgba(0,0,0,.25)",pointerEvents:"auto",maxWidth:420,margin:"0 auto"}}>
        <div style={{display:"flex",gap:5,marginBottom:14}}>
          {tourSteps.map((_,i)=>(
            <div key={i} style={{flex:1,height:3,borderRadius:2,background:i<=stepIndex?"#FF2D6B":"rgba(0,0,0,.1)"}}/>
          ))}
        </div>
        <div style={{fontSize:17,fontWeight:800,color:"#1a1a1a",fontFamily:"Inter,sans-serif",marginBottom:8}}>{step.title}</div>
        <div style={{fontSize:13,color:"#666",fontFamily:"Inter,sans-serif",lineHeight:1.6,marginBottom:20}}>{step.body}</div>
        <div style={{display:"flex",gap:10,alignItems:"center"}}>
          <span onClick={onFinish} style={{fontSize:12.5,color:"#999",fontFamily:"Inter,sans-serif",fontWeight:600,cursor:"pointer",padding:"10px 6px"}}>{tr("tour_skip")}</span>
          <div style={{flex:1}}/>
          <Btn fn={next} style={{background:"linear-gradient(135deg,#FF2D6B,#7B2FFF)",color:"#fff",padding:"11px 24px",borderRadius:40,fontSize:13,fontWeight:700,fontFamily:"Inter,sans-serif"}}>
            {stepIndex>=tourSteps.length-1?tr("tour_finish"):tr("tour_next")}
          </Btn>
        </div>
      </div>
    </div>
  );
}
